
  <div *ngIf="isLoading" class="overlay">
    <mat-spinner></mat-spinner>
  </div>
  <router-outlet />
